module.exports = __webpack_public_path__ + "img/discord.4b9cd65f.png";